// extracted by mini-css-extract-plugin
export default {"container":"PeopleContainer_container__SBGMF","heading":"PeopleContainer_heading__NRyP2","nameColor":"PeopleContainer_nameColor__s1Y7X"};